export default __webpack_public_path__ + "static/media/WhoEatsWhat_06.0def1873.png";